export default "__VITE_PUBLIC_ASSET__e086549e__"